import React from "react";
import MultiSelectDropdown from "./MultiSelectDropdown";
import { cascadeOptions, applyCascade, scopeEnabled } from "./misScope";

// Cascading drill-down scope filter row shared by every MIS report tab:
//   State -> City -> Branch -> Class -> Stream -> Section
// Behaves like the main MIS dashboard filters:
//   - each level unlocks only once its parent has a selection (hierarchical enable)
//   - drilling into a level auto-selects ALL of its downstream options (narrow by unchecking)
//   - Section options respect the selected Stream
//
// Props:
//   scope    — { states, cities, branches, classes, streams, sections } from GET_SCOPE
//   sel      — current selection { state, city, branch, class, stream, section } (arrays)
//   onChange — (nextSel) => void   // receives the FULL next selection object
//   minWidth — optional per-dropdown min width (default 130)
//   style    — wrapper style
export default function ScopeFilters({ scope, sel, onChange, minWidth = 130, style }) {
  const s = sel || {};
  const sc = scope || {};
  const o = cascadeOptions(sc, s);
  const en = scopeEnabled(s);
  const change = (key, v) => onChange(applyCascade(sc, s, key, v));
  const dd = (label, placeholder, key, options, enabled, disabledHint) => (
    <MultiSelectDropdown
      label={label}
      placeholder={enabled ? placeholder : disabledHint}
      minWidth={minWidth}
      disabled={!enabled}
      value={s[key]}
      onChange={(v) => change(key, v)}
      options={options}
    />
  );
  return (
    <div style={style}>
      {dd("State", "All States", "state", o.states.map((x) => ({ value: x.state_id, label: x.state_name })), en.state)}
      {dd("City", "All Cities", "city", o.cities.map((x) => ({ value: x.id, label: x.city_name })), en.city, "Select State first")}
      {/* Branch is chosen once in the header (NavbarOne) and applies to every tab, so it is
          deliberately NOT a per-tab filter here — State/City are derived from that selection. */}
      {dd("Class", "All Classes", "class", o.classes.map((x) => ({ value: x.id, label: x.class })), en.class, "Select City first")}
      {dd("Stream", "All Streams", "stream", o.streams.map((x) => ({ value: x.id, label: x.stream_name })), en.stream, "Select Class first")}
      {dd("Section", "All Sections", "section", o.sections.map((x) => ({ value: x.id, label: x.section_name })), en.section, "Select Class first")}
    </div>
  );
}
